// src/plugins/font-awesome.ts

import { library, IconDefinition } from '@fortawesome/fontawesome-svg-core'
import {
  faTachometerAlt,
  faChevronRight,
  faSlidersH,
  faChartBar,
  faCreditCard,
  faDollarSign,
  faVenusMars,
  faMarsDouble,
  faMercury,
  faTransgender,
  faChild,
  faUserSecret,
  faLifeRing,
  faQuestionCircle,
  faPercent,
  faSignal,
  faTv,
  faMobileAlt,
  faTabletAlt,
  faDesktop,
  faArrowLeft,
  faEye,
  faEyeSlash,
  faUser,
  faLock,
  faPlusCircle,
  faCogs,
  faTimes,
  faChartLine,
  faKey,
  faCopy,
  faStickyNote,
  faBell,
  faEnvelope,
  faHeadset,
  faCheck,
  faBan,
  faComments,
  faSignOut
} from '@fortawesome/free-solid-svg-icons'

import { faTelegram } from '@fortawesome/free-brands-svg-icons'

// Add all icons to the library in one go
library.add(
  faTachometerAlt as IconDefinition,
  faChevronRight as IconDefinition,
  faSlidersH as IconDefinition,
  faChartBar as IconDefinition,
  faCreditCard as IconDefinition,
  faDollarSign as IconDefinition,
  faLifeRing as IconDefinition,
  faPlusCircle as IconDefinition,
  faVenusMars as IconDefinition,
  faMarsDouble as IconDefinition,
  faMercury as IconDefinition,
  faTransgender as IconDefinition,
  faChild as IconDefinition,
  faUserSecret as IconDefinition,
  faQuestionCircle as IconDefinition,
  faPercent as IconDefinition,
  faSignal as IconDefinition,
  faTv as IconDefinition,
  faMobileAlt as IconDefinition,
  faTabletAlt as IconDefinition,
  faDesktop as IconDefinition,
  faArrowLeft as IconDefinition,
  faEye as IconDefinition,
  faEyeSlash as IconDefinition,
  faUser as IconDefinition,
  faLock as IconDefinition,
  faKey as IconDefinition,
  faCopy as IconDefinition,
  faCogs as IconDefinition,
  faTimes as IconDefinition,
  faChartLine as IconDefinition,
  faStickyNote as IconDefinition,
  faBell as IconDefinition,
  faTelegram as IconDefinition,
  faEnvelope as IconDefinition,
  faHeadset as IconDefinition,
  faCheck as IconDefinition,
  faBan as IconDefinition,
  faComments as IconDefinition,
  faSignOut as IconDefinition
)
